const getHash = () =>
    Date.now().toString(36) + Math.random().toString(36).substring(2)
import api from '@/api/customer'
import { errorHandler } from '../exports/error_management'

const state = {
    item: null,
    customerId: null,
    items: [],
    pagination: null,
    customerUser: null,
}

const getters = {
    customers(state) {
        return state.items || []
    },

    customer(state) {
        return state.item || null
    },

    customerUsers(state) {
        const users = ((state.item || {}).users || []).map(x => x.user)
        console.log('users12', users)
        return users
    },

    customerPortalUsers(state) {
        const users = (state.item || {}).users || []
        console.log('users12', users)
        return users
    },
}

const mutations = {
    SET_CUSTOMER(state, payload) {
        state.item = payload
    },
    SET_CUSTOMER_ID(state, customerId) {
        state.customerId = customerId
    },
    SET_CUSTOMERS(state, payload) {
        state.items = payload
    },
    DELETE_CUSTOMER(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
        console.log('deleted item at index ' + index)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
}

const actions = {
    async create(context, payload) {
        try {
            const res = await api.create(payload) //.then(() => {})
            console.log('customer create', res.data.success.data)
            context.commit('SET_CUSTOMER', res.data.success.data)
            context.commit('SET_CUSTOMER_ID', res.data.success.data.id)
            return res.data.success.data
        } catch (err) {
            errorHandler(err)
        }
    },
    async uploadCustomer({ commit, state }, payload) {
        try {
            const result = await api.upload(payload)

            /*   .then(response => response)
            .catch(error => error.response) */

            let success = result.data.success
            let { data } = success == undefined ? {} : success
            if (!data) return result.data.success || result.data.error

            const customers = [...state.items]
            const idx = customers.findIndex(x => x.id === data.id)
            customers.splice(idx === -1 ? customers.length : idx, 1, data)
            commit('SET_CUSTOMERS', customers)
            ///return result.data.success
        } catch (err) {
            errorHandler(err)
        }
    },

    fetch(context, params) {
        console.log
        let { query, page: pg, filters } = params || {}
        query = query || ''
        pg = pg || 1
        return api
            .fetch(query, pg, filters)
            .then(result => {
                let {
                    data,
                    current_page: page,
                    per_page: pageSize,
                    total,
                } = result.data.success.data
                console.log('customers search---', data)
                context.commit('SET_CUSTOMERS', data)
                context.commit('set_pagination', {
                    page,
                    pageSize,
                    total,
                })
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    fetchById(context, id) {
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data: item },
                    },
                }) => {
                    console.log('assumed customer', item)
                    context.commit('SET_CUSTOMER', item)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    update(context, payload) {
        return api
            .update(payload.id, payload)
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },
    delete(context, id) {
        console.log('deleting')
        return api
            .delete(id)
            .then(() => {
                context.commit('DELETE_CUSTOMER', id)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    //////////////////////////////////////customer users//////////////////
    async createUser(context, { customer_id, data }) {
        try {
            console.log('customer create---', { customer_id, data })
            await api.createUser(customer_id, data)
            await context.dispatch('fetchById', customer_id)
        } catch (err) {
            errorHandler(err)
        }
    },
    clear({ commit }) {
        commit('SET_CUSTOMERS', [])
    },
    merge({ state, commit }, item) {
        item.data.hash = item.data.hash || getHash()
        const items = [...state.items]
        let index = items.findIndex(x => x.hash == item.data.hash)
        if (index >= 0) items.splice(index, 1, item.data)
        else items.push(item.data)
        commit('SET_CUSTOMERS', items)
        // commit('SET_ITEMS', items)
    },
    deleteContact({ state, commit }, hash) {
        const customers = [...state.items]
        const index = customers.findIndex(x => x.hash == hash)
        customers.splice(index, 1)
        commit('SET_CUSTOMERS', customers)
    },

    async createContact(context, payload) {
        console.log('customerData', payload)
        try {
            await api.createContact(payload)
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateUser(context, { customer_id, data }) {
        try {
            const userData = { ...data }
            const user_id = data.id
            delete userData.id
            await api.updateUser(customer_id, user_id, userData)
            await context.dispatch('fetchById', customer_id)
        } catch (err) {
            errorHandler(err)
        }
    },
    async deleteUser(context, { customer_id, user_id }) {
        try {
            await api.deleteUser(customer_id, user_id)
            await context.dispatch('fetchById', customer_id)
        } catch (err) {
            errorHandler(err)
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
